import axios from '@/api/config';

const information = {
  getInformationById(data) {
    return axios.get(`${process.env.BASE_URL}/information/getInformation/` + data, {});
  },
  getInformationDetail(data) {
    return axios.get(`${process.env.BASE_URL}/information/getInformationDetail`, {params: data});
  },
  getInformation(data) {
    return axios.get(`${process.env.BASE_URL}/information/getInformation`, {params: data});
  },
  getInformationList(data) {
    return axios.get(`${process.env.BASE_URL}/information/getInformationList`, {params: data});
  },
  getInformationTree(data) {
    return axios.get(`${process.env.BASE_URL}/information/getInformationTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/information/pageList`, data);
  },
  addInformation(data) {
    return axios.post(`${process.env.BASE_URL}/information/addInformation`, data);
  },
  updateInformation(data) {
    return axios.put(`${process.env.BASE_URL}/information/updateInformation`, data);
  },
  deleteInformation(data) {
    return axios.delete(`${process.env.BASE_URL}/information/deleteInformation`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/information/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/information/importData`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/information/active`, data);
  },
}

export default information;



// WEBPACK FOOTER //
// ./src/api/information.js